module.exports = __webpack_public_path__ + "img/answer-img3.1804f01d.png";